import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import apiServices from "../../services/apiServices";

// First, create the thunk
export const fetchAllSuppliers = createAsyncThunk(
  "supplier_state/fetchAllSupplier",
  async () => {
    const response = await apiServices.get("suppliers");
    console.log(response.data.data);
    return response.data.data;
  }
);
export const addSupplier = createAsyncThunk(
  "supplier_state/addSupplier",
  async (data) => {
    const response = await apiServices.post("supplier", data);
    console.log(response.data.data);
    return response.data.data;
  }
);

const initialState = {
  suppliers: [],
  error: "",
};

let supplierSlice = createSlice({
  name: "supplier_state",
  initialState,
  reducers: {
    // insert actions here

    //action 2
    addNewSupplier: function (state, action) {
      // api call for the fetch all supplier from server
      let { payload } = action;
      console.log("payload", payload);

      //return new state
      state.suppliers = [...state.suppliers, payload];

      console.log(state.suppliers);
    },
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(fetchAllSuppliers.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchAllSuppliers.fulfilled, (state, action) => {
      // Add user to the state array
      console.log("supplier : ", action.payload);
      let suppliers= [];
      action.payload &&
        action.payload.map((x) => {
          let supplier = {
            id: x._id,
            firstName: x.firstName,
            lastName: x.lastName,
            homeAddress: x.homeAddress,
            businessAddress: x.businessAddress,
            country: x.country,
            city: x.city,
            mobile: x.mobile,
            email: x.email,
            status: x.status,
          };

          return suppliers.push(supplier);
        });
      state.suppliers = suppliers;
      state.loading = false;
    });
    builder.addCase(fetchAllSuppliers.rejected, (state, action) => {
      state.loading = false;
      state.errorMessage = "Oops !, server error in fetching suppliers";
    });

    // add all supplier
    builder.addCase(addSupplier.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(addSupplier.fulfilled, (state, action) => {
      // Add user to the state array
      let supplier = {
        id: action.payload._id,
        firstName: action.payload.firstName,
        lastName: action.payload.lastName,
        homeAddress: action.payload.homeAddress,
        businessAddress: action.payload.businessAddress,
        country: action.payload.country,
        city: action.payload.city,
        mobile: action.payload.mobile,
        email: action.payload.email,
        status: action.payload.status,
      };
      state.suppliers = [...state.suppliers, supplier];
      state.loading = false;
    });
    builder.addCase(addSupplier.rejected, (state, action) => {
      state.loading = false;
      state.errorMessage = "Oops !, server error in adding supplier";
      console.log(state.errorMessage);
    });
  },
});

export default supplierSlice.reducer;
